// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Harvest-module--wrap--3pMA7","container":"Harvest-module--container--v9bIO","slider":"Harvest-module--slider--3xP1F","textWrap":"Harvest-module--textWrap--32UcX"};